export default class StoreBusinessTimeModel {
  startTime;
  endTime;
  isClosed;

  constructor(data) {
    Object.assign(this, data);
  }
}
